// extracted by mini-css-extract-plugin
module.exports = {"cards":"SelectType-module__cards___Viz9n"};